import { render } from "./Navbar.vue?vue&type=template&id=1103b2c8"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
script.render = render

export default script